<template>
    <div class="pqr" ref="pqrResults">
        <ul class="pqr-grid js-product-query-results" ref="pqrSwiperInstance">
            <li class="pqr-grid__item" v-for="(product, index) in products" data-aos="fade-up" data-aos-once="true">
                <ProductCard
                    :portfolioType="product.portfolio"
                    :url="product.productDetailUrl"
                    :title="product.productDisplayName"
                    :imageUrl="product.primaryImageUrl"
                    :isFinishImageMissing="product.isFinishImageMissing"
                    :beautyImageUrl="product.beautyImageUrl"
                    :description="product.productBrowseDescription"
                    :availability="product.availability"
                    :modelNumber="product.modelNumber"
                    :index="index"
                    :product="product"
                    :translations="translations"
                    :hasQuickship="product.quickShip"
                    :disableComparison="true"
                    :isDiscontinued="product.isDiscontinued"
                    v-on:comparisonItemRemoved="removeComparisonItem"
                >
                </ProductCard>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import ProductCard from 'Vue/components/shared/ProductCard.vue';
import * as AOS from 'aos';
import { variantGrouping, IProductQueryResults } from 'Vue/interfaces/ProductFilteringInterfaces';
import { IProductFilteringTranslations } from 'Vue/interfaces/Interfaces';

export default {
    name: 'ProductQueryResultsGrid',
    components: {
        ProductCard,
    },
    data: () => {
        return {
            moduleData: {} as IProductQueryResults,
            products: [] as variantGrouping[],
            translations: {} as IProductFilteringTranslations,
        };
    },
    methods: {
        getData() {
            let closestParent = this.$refs.pqrResults.closest('.js-product-query-results-grid');
            this.moduleData = JSON.parse(closestParent.getAttribute('data-page-data'));
            this.products = this.moduleData?.products;
        },

        removeComparisonItem() {
            //console.log('comparison item removed');
        },
        getTranslations() {
            let productQParentDivs = document.querySelectorAll('.pqr-module');
            let translationsArray = [];
            productQParentDivs.forEach((pqr) => {
                if (pqr.getAttribute('data-translations')) {
                    let parsedTranslations = JSON.parse(pqr.getAttribute('data-translations'));
                    translationsArray.push(parsedTranslations);
                }
            });

            let translations = translationsArray.reduce(function (result, currentObject) {
                for (let key in currentObject) {
                    if (currentObject.hasOwnProperty(key)) {
                        result[key] = currentObject[key];
                    }
                }
                return result;
            }, {});
            return translationsArray.length ? translations : {};
        },
    },

    mounted() {
        this.getData();
        AOS.init({ startEvent: 'load' });
    },
    created() {
        this.translations = this.getTranslations();
    },
};
</script>
